
define('text!modules/reporting/campaigns/performance/templates/chart.html',[],function () { return '<div class="performance-chart-container">\n  <div id="performance-chart"></div>\n  <div class="no-data-chart-container">\n    {{>chartNoDataChart}}\n  </div>\n</div>\n';});

